/**
 * React component for rendering a video modal.
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} props.isOpen - Flag indicating whether the modal is open.
 * @param {Function} props.openModal - Function to open the modal.
 * @param {Object} props.data - Data for rendering the video modal.
 * @param {string} props.PDPVideoLink - Video link for Product Detail Page.
 * @param {string} props.PDPPosterImage - Poster image for Product Detail Page video.
 * @param {Function} props.setIsHeroVideoLoaded - Function to set the hero video loaded state.
 * @param {string} props.topPadding - Top padding for the modal.
 * @param {string} props.videoTrackingName - Name for tracking the video.
 * @returns {JSX.Element} The rendered VideoModal component.
 */

import React, { useEffect, useRef, useState, useContext } from "react";
import { Dialog } from "@headlessui/react";
import ModalClose from "../../../assets/svg/ModalClose";
import {setLocalStorageValue , getLocalStorageValue} from "../../../src/utils/LocalStorage";
import { Plausible } from "@/providers/PlausibleProvider";
import { buildUrl } from "../LazyVideo/LazyVideoNew";

const LS_KEY = "video_viewed";
const EVENT_NAME = "Video Viewed";

export default function VideoModal({
  isOpen,
  openModal,
  data,
  PDPVideoLink,
  PDPPosterImage,
  setIsHeroVideoLoaded,
  topPadding,
  videoTrackingName
}) {
  var videoSrc;
  var videoPoster;
  const videoRef = useRef();
  const [videoVisible, setVideoVisible] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const { plausibleEvent } = useContext(Plausible);

  if (data) {
    videoSrc = buildUrl(data?.heroSectionTileModalVideo?.fields?.file?.url);
    videoPoster = buildUrl(data?.heroSectionTileModalVideoPoster?.fields?.file?.url);
  }
  if (PDPVideoLink || PDPPosterImage) {
    videoSrc = buildUrl(PDPVideoLink);
    videoPoster = buildUrl(PDPPosterImage);
  }

  const handleVideoPlay = () => {
    if (!videoVisible){
      setVideoVisible(true);
    }
  };

  const onVideoPlay = () => {
    if (!videoPlaying) {
      videoRef.current.play().catch();
      setVideoPlaying(true);
    }
  };

  const handleVideoPause = () => {
    setVideoPlaying(false);
  };

  const handleVideoNotPlay = () => {
    if (setIsHeroVideoLoaded) {
      setIsHeroVideoLoaded(true);
    }
  };

  useEffect(() => {
    if ( isOpen && videoSrc && videoTrackingName ) {
      
      console.log("videoTrackingName", videoTrackingName);
      const watchedVideos = (getLocalStorageValue( LS_KEY ) || "").split(",");
      console.log("watchedVideos", watchedVideos);
      if( watchedVideos.indexOf( videoTrackingName ) > -1 ) {
        return;
      }
      console.log("Tracking ", videoTrackingName);
      plausibleEvent(EVENT_NAME, {
        video_url: videoSrc,
        video_name: videoTrackingName
      });

      watchedVideos.push( videoTrackingName );
      setLocalStorageValue( LS_KEY, watchedVideos.join(","), 0);
    }
  });

  return (
    <Dialog open={isOpen} onClose={() => {}} className={`relative outline-0`}>
      <div className="fixed inset-0 bg-primary50 z-[3]" />
      <div
        className={`fixed inset-0 flex w-screen overflow-y-scroll ${
          PDPVideoLink
            ? `mob:items-start lg:items-center ${topPadding ? `${topPadding}` : "mob:pt-[62%]" } pt-[18%] lg:py-[35px] mob:px-9 px-12`
            : "items-center p-4 md:px-8 lg:p-10"
        } justify-center z-10`}
      >
        <Dialog.Panel className="relative w-[1280px] max-h-[721px] xl:h-full cursor-pointer">
          <video
            ref={videoRef}
            poster={videoPoster}
            className={`custom-video rounded-8 lg:rounded-16 ${
              videoVisible ? "z-[0]" : "-z-[1]"
            }`}
            width="100%"
            height="100%"
            src={videoSrc}
            allowFullScreen
            autoPlay
            playsInline
            controls
            disablePictureInPicture
            controlsList="nodownload noplaybackrate pictureinpicture"
          ></video>
          <span
            onClick={() => openModal()}
            className="text-white absolute close__btn cursor-pointer"
            title="Close"
          >
            <ModalClose />
          </span>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
